import { VueApp } from 'larasnap';
import App from './EmployeePortal.vue';

export default class extends VueApp {
    static registerAs = 'EmployeePortal';

    constructor(element) {
        super(element, App);
    }
}
